import { triggerRequired } from './../classes/GeoThrottle';
import { browserHistory }  from 'react-router'
import { sendMessage }     from './MessageAction';

export const RECEIVE_CLOSEST = 'RECEIVE_CLOSEST';
export const RESET_CLOSEST   = 'RESET_CLOSEST';
export const TRIGGER_CLOSEST = 'TRIGGER_CLOSEST';

export const resetClosest = () => {
    return {
        type: RESET_CLOSEST
    }
};

/**
 * Only to be called by receiveClosest.
 */
const triggerClosestIfNeeded = () =>
{
    return (dispatch, getState) => {
        let trigger;
        let closest = getState().closest;
        if (false === closest.triggered)
        {
            trigger = triggerRequired(getState().geo.coords, closest.item);
            if (trigger)
            {
                dispatch({type: TRIGGER_CLOSEST});
                browserHistory.push('/place/' + closest.item.id);
                dispatch(sendMessage('You have arrived at ' + closest.item.name + '.', 0));
            }
        }
    }
};

/**
 * Receive and store the closest place data, then call triggerClosestIfNeeded
 *
 * @param closest
 */
export const setClosest = (closest) =>
{
    return (dispatch) =>
    {
        dispatch({
            type   : RECEIVE_CLOSEST,
            closest: closest
        });

        dispatch(triggerClosestIfNeeded());
    }
};


// WEBPACK FOOTER //
// ./src/actions/ClosestAction.js